import React, { useEffect, useState } from 'react';
import { Scan, ChevronDown, Play, CheckCircle } from 'lucide-react';
import { TopNav } from './TopNav';
import { motion, AnimatePresence } from 'framer-motion';
type Screen = 'login' | 'success';
interface RFIDScanScreenProps {
  onScan: (rfidCode: string) => void;
}
export function RFIDScanScreen({
  onScan
}: RFIDScanScreenProps) {
  const [isNavVisible, setIsNavVisible] = useState(true);
  const [currentScreen, setCurrentScreen] = useState<Screen>('login');
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsNavVisible(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (currentScreen === 'success') {
      const timer = setTimeout(() => {
        // Call onScan to trigger login in App.tsx
        onScan('RFID-001');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [currentScreen, onScan]);
  const showNav = () => {
    setIsNavVisible(true);
    setTimeout(() => {
      setIsNavVisible(false);
    }, 3000);
  };
  const handleDemo = () => {
    setCurrentScreen('success');
  };
  return <div className="min-h-screen w-full bg-white" data-id="element-760">
      <TopNav isVisible={isNavVisible} data-id="element-761" />

      {!isNavVisible && <button onClick={showNav} className="fixed top-0 left-1/2 -translate-x-1/2 z-50 bg-white border border-gray-200 rounded-b-lg px-4 py-2 shadow-sm hover:bg-gray-50 transition-colors" aria-label="Menü anzeigen" data-id="element-762">
          <ChevronDown className="w-5 h-5 text-gray-600" strokeWidth={1.5} data-id="element-763" />
        </button>}

      <div className="flex items-center justify-center min-h-screen px-8" data-id="element-764">
        <AnimatePresence mode="wait" data-id="element-765">
          {currentScreen === 'login' && <motion.div key="login" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} className="text-center space-y-16 max-w-3xl" data-id="element-766">
              <div className="space-y-3" data-id="element-767">
                <h1 className="text-6xl font-semibold text-gray-900 tracking-tight" data-id="element-768">
                  Anmelden
                </h1>
                <p className="text-lg text-gray-500" data-id="element-769">
                  Halten Sie Ihren Chip an das Lesegerät
                </p>
              </div>

              <div className="flex justify-center py-12" data-id="element-770">
                <div className="relative" data-id="element-771">
                  <div className="absolute inset-0 bg-blue-50 rounded-3xl blur-2xl opacity-40" data-id="element-772" />
                  <div className="relative bg-gradient-to-br from-gray-50 to-blue-50/30 rounded-2xl p-12 border border-gray-200/50 shadow-lg" data-id="element-773">
                    <Scan className="w-40 h-40 text-blue-600" strokeWidth={1.5} data-id="element-774" />
                  </div>
                </div>
              </div>
            </motion.div>}

          {currentScreen === 'success' && <motion.div key="success" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.4
        }} className="text-center space-y-8 max-w-2xl" data-id="element-775">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 0.2,
            type: 'spring',
            stiffness: 200
          }} data-id="element-776">
                <CheckCircle className="w-24 h-24 text-green-600 mx-auto" strokeWidth={1.5} data-id="element-777" />
              </motion.div>

              <div className="space-y-4" data-id="element-778">
                <h2 className="text-5xl font-semibold text-gray-900" data-id="element-779">
                  Max Mustermann
                </h2>
                <p className="text-xl text-gray-600" data-id="element-780">Personalnummer: 120938</p>
                <p className="text-lg text-gray-500 mt-6" data-id="element-781">wurde angemeldet</p>
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>

      {currentScreen === 'login' && <button onClick={handleDemo} className="fixed bottom-6 right-6 flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-blue-600 text-gray-700 hover:text-white rounded-full text-sm font-medium transition-colors shadow-sm border border-gray-200 hover:border-blue-600" aria-label="Demo starten" data-id="element-782">
          <Play className="w-4 h-4" strokeWidth={2} data-id="element-783" />
          Demo
        </button>}
    </div>;
}